/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Ratna Kirti",
  title: "Hi all, I'm Ratna",
  subTitle: emoji(
    "A passionate Computer Science graduate with 20+ professional certifications spanning AI, full-stack development, and IT service management. 🚀 I love building innovative web applications with cutting-edge technologies and solving complex problems with clean, efficient code!"
  ),
  resumeLink:
    "/resume.pdf", // Local resume file in public folder
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/ratna3", 
  linkedin: "https://www.linkedin.com/in/ratna-kirti", 
  gmail: "mailto:ratnakirtiscr@gmail.com", 
  facebook: "https://www.facebook.com/ratna.kirti.3",  
  instagram: "https://www.instagram.com/ratnakirtiii/", 
  twitter: "https://x.com/RatnaKirti1",
  stackoverflow: "https://stackoverflow.com/users/31130088/ratna-kirti", 
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "PASSIONATE DEVELOPER WHO LOVES TO EXPLORE NEW TECHNOLOGIES",
  skills: [
    emoji(
      "⚡ Develop modern web applications using Next.js, React, TypeScript, and Tailwind CSS"
    ),
    emoji("⚡ Building scalable applications with Firebase, Genkit, and ShadCN UI components"),
    emoji(
      "⚡ Full-stack development with Node.js, Python, and cloud-native architectures"
    ),
    emoji(
      "⚡ Database design and optimization with SQL and NoSQL technologies"
    ),
    emoji(
      "⚡ Problem-solving with data structures, algorithms, and AI/ML technologies"
    ),
    emoji(
      "⚡ Cloud-native development with Docker, Kubernetes and microservices architecture"
    )
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "Next.js",
      fontAwesomeClassname: "fas fa-code"
    },
    {
      skillName: "React",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "TypeScript",
      fontAwesomeClassname: "fas fa-code"
    },
    {
      skillName: "Tailwind CSS",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "ShadCN UI",
      fontAwesomeClassname: "fas fa-palette"
    },
    {
      skillName: "Genkit",
      fontAwesomeClassname: "fas fa-cogs"
    },
    {
      skillName: "Firebase",
      fontAwesomeClassname: "fas fa-fire"
    },
    {
      skillName: "Java",
      fontAwesomeClassname: "fab fa-java"
    },
    {
      skillName: "Python",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "Node.js",
      fontAwesomeClassname: "fab fa-node"
    },
    {
      skillName: "html-5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "css3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "C++",
      fontAwesomeClassname: "fas fa-code"
    },
    {
      skillName: "C",
      fontAwesomeClassname: "fas fa-code"
    },
    {
      skillName: "C#",
      fontAwesomeClassname: "fas fa-code"
    },
    {
      skillName: "sql-database",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "MongoDB",
      fontAwesomeClassname: "fas fa-leaf"
    },
    {
      skillName: "git",
      fontAwesomeClassname: "fab fa-git-alt"
    },
    {
      skillName: "docker",
      fontAwesomeClassname: "fab fa-docker"
    },
    {
      skillName: "Ruby",
      fontAwesomeClassname: "fas fa-gem"
    },
    {
      skillName: "Haskell",
      fontAwesomeClassname: "fas fa-code"
    },
    {
      skillName: "Maven",
      fontAwesomeClassname: "fas fa-cogs"
    },
    {
      skillName: "SpringBoot",
      fontAwesomeClassname: "fas fa-leaf"
    },
    {
      skillName: "Elixir",
      fontAwesomeClassname: "fas fa-code"
    },
    {
      skillName: "Kotlin",
      fontAwesomeClassname: "fas fa-code"
    },
    {
      skillName: "Kubernetes",
      fontAwesomeClassname: "fas fa-dharmachakra"
    },
    {
      skillName: "CUDA",
      fontAwesomeClassname: "fas fa-microchip"
    },
    {
      skillName: "OpenMPI",
      fontAwesomeClassname: "fas fa-network-wired"
    },
    {
      skillName: "MIPS Assembly",
      fontAwesomeClassname: "fas fa-microchip"
    },
    {
      skillName: "Go",
      fontAwesomeClassname: "fas fa-code"
    },
    {
      skillName: "Micro Services",
      fontAwesomeClassname: "fas fa-cubes"
    },
    {
      skillName: "Nvidia Gen AI",
      fontAwesomeClassname: "fas fa-brain"
    },
    {
      skillName: "Adobe Suite",
      fontAwesomeClassname: "fas fa-paint-brush"
    },
    {
      skillName: "Godot",
      fontAwesomeClassname: "fas fa-gamepad"
    },
    {
      skillName: "Blender",
      fontAwesomeClassname: "fas fa-cube"
    },
    {
      skillName: "Google Workspace",
      fontAwesomeClassname: "fab fa-google"
    },
    {
      skillName: "GitHub Pages",
      fontAwesomeClassname: "fab fa-github"
    },
    {
      skillName: "Microsoft Suite",
      fontAwesomeClassname: "fab fa-microsoft"
    },
    {
      skillName: "Tableau",
      fontAwesomeClassname: "fas fa-chart-bar"
    },
    {
      skillName: "VS Code",
      fontAwesomeClassname: "fas fa-code"
    },
    {
      skillName: "BlueJ",
      fontAwesomeClassname: "fas fa-code"
    },
    {
      skillName: "Eclipse",
      fontAwesomeClassname: "fas fa-code"
    },
    {
      skillName: "Kraken",
      fontAwesomeClassname: "fas fa-tools"
    },
    {
      skillName: "Jupyter Notebook",
      fontAwesomeClassname: "fas fa-book"
    },
    {
      skillName: "GitHub Desktop",
      fontAwesomeClassname: "fab fa-github"
    },
    {
      skillName: "Command Prompt",
      fontAwesomeClassname: "fas fa-terminal"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Knox College", // Replace with your university
      logo: require("./assets/images/Fox.jpg"), // Replace with your university logo
      subHeader: "Bachelor of Science in Computer Science",
      duration: "2020 - 2024", // Replace with your dates
      desc: "Graduated with a strong foundation in computer science fundamentals and programming.",
      descBullets: [
        "Coursework: Data Structures, Algorithms, Software Engineering, Database Systems, Parallel Programming, 3D Computer Graphics, Software Development and its Professional Practices and Data Mining",
        "Programming Languages: Java, JavaScript, CSS, C#, React.js, Python, C, C++, SQL, Ruby, Haskell, MIPS Assembly Language, HTML, Maven, SpringBoot, Elixir, Docker, Kotlin, Go, OpenMPI, MongoDB, CUDA, Kubernetes and Micro Services",
        "Projects: Software Development, Mobile Apps, Database Design, Web Development, and Game Development",
      ]
    },
    {
      schoolName: "Knox College",
      logo: require("./assets/images/Fox.jpg"),
      subHeader: "Business Administration Minor",
      duration: "2023 - 2025",
      desc: "Pursuing a minor in Business Administration to complement technical skills with business acumen.",
      descBullets: [
        "Relevant Coursework: BUSS 211 Principles of Accounting I, BUS 212 Accounting II, BUS 242 Business Computing, BUS 333 Managerial Finance"
      ]
    },
    {
      schoolName: "City Montessori School",
      logo: require("./assets/images/cms.jpg"), 
      subHeader: "Diploma in High School",
      duration: "2007 - 2021",
      desc: "Completed secondary education with excellent academic performance at the world's largest school by student enrollment (Guinness World Record holder).",
      descBullets: [
        "🏆 Studied at the world's largest school with over 55,000+ students - officially recognized by Guinness World Records",
        "Academic Excellence: ICSE (Indian Certificate of Secondary Education) - 92% | ISC (Indian School Certificate) - 90%",
        "Core Subjects: English, Sanskrit, Hindi languages and literature, STEM disciplines",
        "Global Recognition: Part of an institution that holds the prestigious Guinness World Record for largest school by pupils"
      ]
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Software Developement (Backend and Frontend)", //Insert stack or technology you have experience in
      progressPercentage: "90%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Game Development",
      progressPercentage: "75%"
    },
    {
      Stack: "Database Management",
      progressPercentage: "70%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: false, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Software Developer Intern",
      company: "Your Company", // Replace with actual company
      companylogo: require("./assets/images/profile.jpg"), // Replace with company logo
      date: "Summer 2024",
      desc: "Developed web applications using modern technologies and collaborated with senior developers on various projects.",
      descBullets: [
        "Built responsive web interfaces using React and JavaScript",
        "Worked on database optimization and API development"
      ]
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Big Projects",
  subtitle: "SOME PROJECTS THAT I HAVE WORKED ON DURING MY ACADEMIC JOURNEY",
  projects: [
    {
      image: require("./assets/images/donai.jpeg"), 
      projectName: "DON.ai - AI-Powered Creative Suite",
      projectDesc: "🎨 DON.ai is a revolutionary AI-powered creative platform offering a complete suite of professional tools - all available for FREE! \n\n✨ Key Features:\n• Advanced Image Editor with AI-powered tools\n• Professional Video Editor with smart automation\n• Intelligent Music Editor for audio creation with AI Auto Tune\n• Cutting-edge AI IDE for development\n\n🚀 Built with Modern Technologies:\n• Frontend: React, TypeScript, Next.js, Vue.js\n• Backend: Node.js, Python, Express, FastAPI\n• AI/ML: Hugging Face, TensorFlow, PyTorch\n• Cloud: FireBase, GenKit,GitHub Actions\n• Design: Canvas APIs, SVG manipulation\n\n🌟 Experience the future of creative technology today!",
      footerLink: [
        {
          name: "Try DON.ai Free",
          url: "https://studio--donai-q6ylp.us-central1.hosted.app/"
        }
      ]
    },
    {
      image: require("./assets/images/CoCreate_Pitch.jpg"),
      projectName: "CoCreate Pitch 2025 Semi Finalist Top 70 Las Vegas",
      projectDesc: "CoCreate Pitch is a premier product-driven startup competition offering bold entrepreneurs the chance to pitch their vision, connect with top global manufacturers and investors, and compete for a share of a $1 million prize pool. Supported by star mentors, extensive exposure, and the full power of Alibaba.com's sourcing ecosystem, the event serves as a launchpad for global success, with the core mission of proving, \"We Can Make It.\"",
      footerLink: [
        {
          name: "My LinkedIn Post",
          url: "https://www.linkedin.com/posts/ratna-kirti_teamwork-collaboration-nevergiveup-ugcPost-7376195157190369280-aPU7?utm_source=share&utm_medium=member_desktop&rcm=ACoAADffQmoBu9uvPUvX5s62SWfPKu8brn4Vxuo" 
        },
      ]
    },
    {
      image: require("./assets/images/pyscope.png"),
      projectName: "Macro Consortium - pyscope",
      projectDesc: "🔭 pyscope is a pure-Python package for control of small robotic telescopes, making astronomical observations accessible and automated.\n\n✨ Key Features:\n• Simple interface for telescope control\n• Camera and peripheral management\n• Easy image capture capabilities\n• Astronomical observation automation\n\n🛠️ Technologies Used:\n• Pure Python implementation\n• Robotic telescope integration\n• Observatory control systems\n• Astronomical imaging tools\n\n🌟 Simplifying the cosmos, one observation at a time!",
      footerLink: [
        {
          name: "Macro Consortium - pyscope",
          url: "https://pypi.org/project/pyscope/" 
        },
        {
          name: "GitHub",
          url: "https://github.com/Knox-College-Computer-Science/Scheduling2-pyscope" 
        }
      ]
    },
    {
      image: require("./assets/images/godot.png"),
      projectName: "2D Side-Scrolling Game",
      projectDesc: "🎮 A dynamic 2D shooter game developed using the Godot Engine. This game challenges players to master precision and timing by performing impressive 360-degree no-scope shots.\n\n🎯 Key Features:\n• Fast-paced action gameplay\n• Precision-based shooting mechanics\n• 360-degree no-scope challenges\n• Smooth side-scrolling experience\n\n🛠️ Built With:\n• Godot Engine\n• 2D Graphics & Animation\n• Physics-based mechanics\n• Custom game logic\n\n🚀 Designed for fast-paced action and skillful gameplay, 360 No Scope offers an engaging experience that tests your reflexes in a unique and exciting way!",
      footerLink: [
        {
          name: "GitHub",
          url: "https://github.com/Vysubs28/360-No-Scope/tree/main" 
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Certifications, Projects, and Cool Stuff that I have accomplished during my journey!",

  achievementsCards: [
    {
      title: "Full-Stack JavaScript Development: MongoDB, Node, and React by Samer Buna",
      subtitle:
        "Full-stack JavaScript Developer specializing in the MERN stack (MongoDB, Express.js, React, Node.js). My portfolio showcases a range of projects built with robust back-end APIs, dynamic front-end interfaces, and scalable database solutions.",
      image: require("./assets/images/fullstack.jpg"), 
      imageAlt: "Full-Stack JavaScript Development",
      footerLink: [
        {
          name: "View Certificate",
          url: "https://lnkd.in/gsduHDH5" 
        }
      ]
    },
    {
      title: "Essential Skills in Generative AI for Creatives",
      subtitle: "Professional certification demonstrating foundational skills in Generative AI tailored for creative professionals. This credential highlights proficiency in using AI tools to enhance creative workflows, generate innovative content, and understand the ethical implications of AI in creative industries.",
      image: require("./assets/images/adobe.jpg"),
      imageAlt: "Essential Skills in Generative AI for Creatives",
      footerLink: [
        {
          name: "View Certificate",
          url: "https://lnkd.in/gbNAwe2e"
        }
      ]
    },
    {
      title: "Microsoft Azure AI Essentials Professional Certificate by Microsoft and LinkedIn",
      subtitle:
        "With a Microsoft Azure AI Essentials Professional Certificate, I possess the foundational knowledge required to design and implement AI-powered solutions on Microsoft Azure. This credential demonstrates my commitment to staying at the forefront of cloud-based AI technologies, ready to apply these skills to innovative and impactful projects.",
      image: require("./assets/images/ai.jpg"),
      imageAlt: "Microsoft Azure AI Essentials Professional Certificate by Microsoft and LinkedIn",
      footerLink: [
        {
          name: "View Certificate",
          url: "https://www.linkedin.com/learning/certificates/ed12fac49390ad65ee2ca650fea8b5771f76bbdb677294e0f563e8440f9b459f" 
        }
      ]
    },
    {
      title: "Atlassian IT Service Management (ITSM) Professional Certificate",
      subtitle: "This certificate was a fantastic deep dive into modern ITSM practices, covering everything from service desk essentials and change management to monitoring and metrics. I'm excited to apply these new skills to help organizations streamline their processes and deliver top-notch service. ",
      image: require("./assets/images/at.jpg"),
      imageAlt: "Atlassian IT Service Management (ITSM) Professional Certificate",
      footerLink: [
        {
          name: "View Certificate",
          url: "https://lnkd.in/g6K2_baa" 
        }
      ]
    },
    {
      title: "Atlassian's IT Service Desk: Service Management By: Fancy Mills-Knebel and HDI",
      subtitle: "Demonstrating a commitment to excellence in IT support and operations, I hold the Atlassian's IT Service Desk: Service Management certification. This foundational knowledge, derived from comprehensive training by Fancy Mills-Knebel and HDI, enables me to contribute to professional and effective service management within diverse organizational settings.",
      image: require("./assets/images/it.jpg"),
      imageAlt: "Atlassian's IT Service Desk: Service Management",
      footerLink: [
        {
          name: "View Certificate",
          url: "https://www.linkedin.com/learning/certificates/eda523289dd3e73fe715f7b8790e422f8bcbc09003a26c9d2caf0c066bf5e246" 
        }
      ]
    },
    {
      title: "Atlassian IT Service Management Foundations: Problem Management",
      subtitle: "Professional certification demonstrating understanding of IT service management principles, with a focus on problem management processes and best practices. This credential equips professionals to effectively identify, analyze, and resolve IT service issues, ensuring minimal disruption to business operations.",
      image: require("./assets/images/problemm.jpg"),
      imageAlt: "IT Service Management Foundations: Problem Management",
      footerLink: [
        {
          name: "View Certificate",
          url: "https://www.linkedin.com/learning/certificates/37d843a4ee4c962635a5d1a217a5b854a38d8d242d6e21264881662dd7272dc0?trk=share_certificate"
        }
      ]
    },
    {
      title: "Atlassian's IT Service Management Foundations: Change Management",
      subtitle: "Demonstrating a commitment to excellence in IT support and operations, I hold the Atlassian's IT Service Management Foundations: Change Management certification. This course has given me a solid understanding of how to manage change effectively and smoothly, ensuring stability and reducing risk. I'm looking forward to applying these key principles to help teams and organizations navigate change with confidence.",
      image: require("./assets/images/change.jpg"),
      imageAlt: "Atlassian's IT Service Management Foundations: Change Management",
      footerLink: [
        {
          name: "View Certificate",
          url: "https://www.linkedin.com/learning/certificates/eda523289dd3e73fe715f7b8790e422f8bcbc09003a26c9d2caf0c066bf5e246" 
        }
      ]
    },
    {
      title: "Atlassian's IT Service Desk: Monitoring and Metrics Fundamentals",
      subtitle: "Demonstrating a commitment to excellence in IT support and operations, I hold the Atlassian's IT Service Management Foundations: Change Management certification. This course was a deep dive into the importance of data-driven decisions in IT service management. I now have a solid understanding of how to use key metrics and monitoring to boost efficiency, improve performance, and deliver better service. I'm ready to put these new skills into action",
      image: require("./assets/images/metrics.jpg"),
      imageAlt: "Atlassian's IT Service Desk: Monitoring and Metrics Fundamentals",
      footerLink: [
        {
          name: "View Certificate",
          url: "https://lnkd.in/gjrJCb7R" 
        }
      ]
    },
    {
      title: "GitHub Copilot Challenge",
      subtitle: "Earners of this badge will have demonstrated the ability to efficiently use GitHub Copilot for coding, documentation, and unit testing. They will have shown proficiency in AI-assisted development and applied these skills in a practical project.",
      image: require("./assets/images/badge.png"),
      imageAlt: "GitHub Copilot Challenge",
      footerLink: [
        {
          name: "View Credly Badge",
          url: "https://www.credly.com/badges/de951714-3ac4-4d33-ab8c-091b609c744c/linked_in_profile"
        }
      ]
    },
     {
      title: "Ethical Hacking: The Complete Malware Analysis Process by Malcolm Shorea",
      subtitle: "The course provided invaluable skills in reverse engineering using powerful tools like Ghidra, the NSA's recommended framework. I now have a clearer understanding of how complex malware, such as the BlackEnergy2 virus, operates from delivery to execution.",
      image: require("./assets/images/Ethical_Hacking.jpg"),
      imageAlt: "Ethical Hacking: The Complete Malware Analysis Process by Malcolm Shorea",
      footerLink: [
        {
          name: "View Certificate",
          url: "https://lnkd.in/gGpwuFXD"
        }
      ]
    },
    {
      title: "Project Management Institute (PMI)®'s Cert Prep: Scrum Master (2018)",
      subtitle: "My PMI Certified Scrum Master credential validates my ability to guide teams in the Scrum framework, expertly facilitating events and leveraging tools like burn-down charts to drive collaborative, high-value project delivery. This showcases my expertise in fostering self-organizing teams and navigating change to achieve project goals.",
      image: require("./assets/images/PMIScrum_Master.jpg"),
      imageAlt: "Project Management Institute (PMI)®'s Cert Prep: Scrum Master (2018)",
      footerLink: [
        {
          name: "View Certificate",
          url: "https://www.linkedin.com/learning/certificates/d05acb175ffb0e53578798ed95c29b81d8bb047b67e4a5ceb6f7306e20a322f9?trk=share_certificate"
        }
      ]
    },
    {
      title: "National Association of State Boards of Accountancy (NASBA)'s Cert Prep: Scrum Master (2018)",
      subtitle: "My NASBA Certified Scrum Master credential validates my ability to guide teams in the Scrum framework, expertly facilitating events and leveraging tools like burn-down charts to drive collaborative, high-value project delivery. This showcases my expertise in fostering self-organizing teams and navigating change to achieve project goals.",
      image: require("./assets/images/nasbaScrum_Master.jpg"),
      imageAlt: "National Association of State Boards of Accountancy (NASBA)'s Cert Prep: Scrum Master (2018)",
      footerLink: [
        {
          name: "View Certificate",
          url: "https://www.linkedin.com/learning/certificates/41759a30f481d3c5ae341aaa4a8e11013a4afc41778cc3f6bffcf863f3edb32a?trk=share_certificate"
        }
      ]
    },
    {
      title: "React.js: Building an Interface By: Ray Villalobos",
      subtitle: "As a full-stack JavaScript developer, my portfolio highlights my commitment to crafting exceptional user experiences, reinforced by my certification in React.js: Building an Interface by Ray Villalobos. This specialized training ensures my front-end solutions are not only visually compelling but also highly interactive, efficient, and built with industry best practices, complementing robust back-end systems.",
      image: require("./assets/images/reactcert.jpg"),
      imageAlt: "React.js: Building an Interface By: Ray Villalobos",
      footerLink: [
        {
          name: "View Certificate",
          url: "https://lnkd.in/gXgFB_cW"
        }
      ]
    },
    {
      title: "Learning Redux Toolkit",
      subtitle: "Comprehensive training in Redux Toolkit, focusing on efficient state management, asynchronous logic, and best practices for scalable React applications.",
      image: require("./assets/images/redux.jpg"),
      imageAlt: "Learning Redux Toolkit",
      footerLink: [
        {
          name: "View Certificate",
          url: "https://lnkd.in/gM_PCyrq"
        }
      ]
    },
     {
      title: "D3.js Essential Training",
      subtitle: "Comprehensive training in D3.js, focusing on data visualization, interactive charts, and best practices for creating dynamic and responsive visual representations of data.",
      image: require("./assets/images/d3.jpg"),
      imageAlt: "D3.js Essential Training",
      footerLink: [
        {
          name: "View Certificate",
          url: "https://lnkd.in/gtJ5Yg52"
        }
      ]
    },
    {
      title: "Angular Essential Training",
      subtitle: "Professional certification demonstrating understanding of Angular framework, including components, directives, services, and best practices for building dynamic web applications. This credential equips developers with the skills to create responsive and maintainable applications using Angular.",
      image: require("./assets/images/angular.jpg"),
      imageAlt: "Angular Essential Training",
      footerLink: [
        {
          name: "View Certificate",
          url: "https://lnkd.in/gE-ygVjr"
        }
      ]
    },
    {
      title: "Practical GitHub Actions By: Ray Villalobos",
      subtitle: "Professional-level certification demonstrating advanced skills in GitHub Actions for CI/CD, including workflow automation, testing, and deployment strategies.",
      image: require("./assets/images/githubac.jpg"),
      imageAlt: "Practical GitHub Actions By: Ray Villalobos",
      footerLink: [
        {
          name: "View Certificate",
          url: "https://www.linkedin.com/learning/certificates/0080935b2bcccfe2a98e06782cf94afac2ff805312745b05b87d621630502814"
        }
      ]
    },
    {
      title: "Introduction to Model Context Protocol By: Anthropic Education",
      subtitle: "Professional certification demonstrating expertise in Model Context Protocol (MCP), a standardized protocol for connecting AI systems with external data sources and tools. This credential showcases advanced understanding of AI integration patterns, context management, and building robust AI-powered applications with enhanced capabilities.",
      image: require("./assets/images/anthropicmcp.jpg"),
      imageAlt: "Introduction to Model Context Protocol By: Anthropic Education",
      footerLink: [
        {
          name: "View Certificate",
          url: "https://verify.skilljar.com/c/rqadmm8qbaiz"
        }
      ]
    },
    {
      title: "What Is Generative AI?",
      subtitle: "Professional certification demonstrating expertise in Generative AI, a cutting-edge technology that enables machines to create content, from text to images and beyond. This credential showcases advanced understanding of AI models, creative applications, and the ethical considerations of AI-generated content.",
      image: require("./assets/images/GenerativeAI.jpg"),
      imageAlt: "What Is Generative AI?",
      footerLink: [
        {
          name: "View Certificate",
          url: "https://www.linkedin.com/learning/certificates/ce7b3d588ce9594a838662472f860ada9442fdd1514e54274cadc72d23e0517e?trk=share_certificate"
        }
      ]
    },
    {
      title: "Generative AI Imaging: What Creative Pros Need to Know",
      subtitle: "Industry-recognized certification demonstrating expertise in Generative AI Imaging, a transformative technology that empowers creative professionals to produce innovative visual content. This credential highlights advanced knowledge of AI-driven design techniques, ethical considerations, and practical applications in various creative fields.",
      image: require("./assets/images/genaipro.jpg"),
      imageAlt: "Generative AI Imaging: What Creative Pros Need to Know",
      footerLink: [
        {
          name: "View Certificate",
          url: "https://www.linkedin.com/learning/certificates/fb9d4007671a5f96921e05d1fedc1c52ef083054ebfd16cdd8110fe524c31596?trk=share_certificate"
        }
      ]
    },
    {
      title: "Leveraging AI in Adobe Photoshop and Creative Cloud",
      subtitle: "Industry-recognized certification demonstrating expertise in leveraging AI tools within Adobe Photoshop and Creative Cloud. This credential highlights advanced knowledge of AI-driven design techniques, ethical considerations, and practical applications in various creative fields.",
      image: require("./assets/images/create.jpg"),
      imageAlt: "Leveraging AI in Adobe Photoshop and Creative Cloud",
      footerLink: [
        {
          name: "View Certificate",
          url: "https://lnkd.in/gRBJDYiM"
        }
      ]
    },
    {
      title: "Generative AI: Business and Legal Concerns for Creatives",
      subtitle: "Professional certification demonstrating understanding of the business and legal implications of Generative AI in creative industries. This credential highlights knowledge of copyright, intellectual property rights, and ethical considerations in AI-generated content, equipping professionals to navigate the evolving landscape of AI in creative fields.",
      image: require("./assets/images/business.jpg"),
      imageAlt: "Generative AI: Business and Legal Concerns for Creatives",
      footerLink: [
        {
          name: "View Certificate",
          url: "https://www.linkedin.com/learning/certificates/bb9bbf9c44357a1b494c4496ae2536a972fd6a05e6f545cb2f6294c7f646c280?trk=share_certificate"
        }
      ]
    },
    {
      title: "Practical GitHub Project Management and Collaboration By: Ray Villalobos",
      subtitle: "Industry-standard certification covering project management principles, collaboration strategies, and best practices for using GitHub in team environments.",
      image: require("./assets/images/manage.jpg"),
      imageAlt: "Practical GitHub Project Management and Collaboration By: Ray Villalobos",
      footerLink: [
        {
          name: "View Certificate",
          url: "https://www.linkedin.com/learning/certificates/595998e9027e9f8dd408934e49930584e787027bbef1b997a77773db71d806b2?trk=share_certificate"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Ratna Talks YT",
  subtitle:
    "Ready to dive into the awesome world of AI? 🤩 I'm Ratna Kirti, your friendly neighborhood Full Stack Software Developer with a MERN superpower! 🦸‍♀️ On this channel, we're cutting through the tech jargon to bring you the real deal on AI. Think of me as your personal guide, serving up practical dos and don'ts to help you rock the latest tech without feeling lost. No gatekeeping, just pure, unadulterated knowledge to unleash your inner AI wizard! ✨ Let's learn, grow, and build amazing things together! 🛠️",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://www.youtube.com/watch?v=z0hLBdX6DTQ&t=318s",
      title: "Create a React application using GitHub Copilot's Agent mode | Ratna Talks | Day 1",
      description:
        "We cover everything from setting up your environment to generating a full React app with the power of AI. Say goodbye to manual boilerplate and hello to efficient development!"
    },
    {
      url: "https://www.youtube.com/watch?v=djqNy8Q4mTc&t=1s",
      title: "Ratna Talks Presents | 3D with Three.js & Cannon.js! Plus, Master AI with GitHub Copilot!",
      description:
        "🎮✨ Get ready to dive into the ultimate 3D adventure! We're building a Minecraft-like world right in your browser, combining the visual magic of Three.js with the realistic physics of Cannon.js to bring your blocky creations to life! 🚀🧱💻 But it's not just about game development; we're also tackling a crucial skill for every modern developer: preventing AI \"hallucinations.\" 🧠🔍 I'll reveal my pro tips using .github/copilot-instructions.md to ensure Microsoft Copilot always generates super accurate, reliable code, turning AI headaches into coding triumphs! ✨"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "Ratna Talks",
  subtitle: emoji(
    "Welcome! I'm Ratna Kirti, a Full Stack Software Developer specializing in MERN 💻. On this channel, I'm all about demystifying AI 🤖 and sharing practical dos and don'ts to help everyone navigate the latest technologies. I believe in open knowledge 🧠, so no gatekeeping here—just real insights to empower you with AI! ✨"
  ),

  talks: [
    {
      title: "Ratna Talks Presents | Copilot Chat Cookbook",
      subtitle: "Find examples of prompts to use with GitHub Copilot Chat.",
      slides_url: "https://docs.github.com/en/copilot/tutorials/copilot-chat-cookbook",
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT TECHNOLOGY AND DEVELOPMENT",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    // Add your podcast links here when available
  ],
  display: false // Set false to hide this section, defaults to true
};

// Resume Section
const resumeSection = {
  title: "Resume",
  subtitle: "Feel free to download my resume",

  // Please Provide with Your Podcast embeded Link
  display: true // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "+1 309-315-2237", 
  email_address: "ratnakirtiscr@gmail.com" // Replace with your email
};

// Twitter Section

const twitterDetails = {
  userName: "RatnaKirti1", //Replace "ratna" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

const isHireable = false; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable,
  resumeSection
};
